import { z } from 'zod';

export const AuditLogRowSchema = z.object({
  id: z.string(), // BigInt 序列化為字串
  userId: z.number().int().nullable(),
  user: z
    .object({
      id: z.number().int(),
      displayName: z.string(),
      username: z.string(),
    })
    .nullable()
    .optional(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.number().int(),
  diff: z.any().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type AuditLogRow = z.infer<typeof AuditLogRowSchema>;

export const AuditLogListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(200).default(50),
  userId: z.coerce.number().int().positive().optional(),
  entityType: z.string().trim().max(30).optional(),
  action: z.string().trim().max(50).optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
});
export type AuditLogListQuery = z.infer<typeof AuditLogListQuerySchema>;
